import React, { useEffect, useState } from 'react';
const COUNTDOWN_DURATION = 15 * 60;
const COUNTDOWN_STORAGE_KEY = 'urgency_bar_15_min_end_time';
function startNewCountdown() {
  const endTime = Date.now() + COUNTDOWN_DURATION * 1000;
  localStorage.setItem(COUNTDOWN_STORAGE_KEY, String(endTime));
  return COUNTDOWN_DURATION;
}
function getTimeLeft() {
  const savedEndTime = Number(localStorage.getItem(COUNTDOWN_STORAGE_KEY));
  return Math.max(0, Math.floor((savedEndTime - Date.now()) / 1000));
}
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(startNewCountdown);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setTimeLeft(getTimeLeft());
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="sticky top-0 z-50 border-b-2 border-red-600 bg-black px-4 py-3 text-white shadow-[0_4px_24px_rgba(220,38,38,0.55)]" data-id="element-413" data-mp="2b6cdex7x52ei">
      <div className="max-w-7xl mx-auto flex items-center justify-between gap-3" data-id="element-414" data-mp="1wo0xshlixoee">
        <div className="flex flex-col" data-id="element-415" data-mp="1wq3zhyw1h5yy">
          <span className="text-sm md:text-base font-black tracking-wide text-red-500 animate-pulse" data-id="element-416" data-mp="1hzmw49zug5zf">
            🔥 ¡OFERTA EXCLUSIVA!
          </span>
          <span className="text-xs md:text-sm font-semibold text-red-100" data-id="element-417" data-mp="1mw4yx4bm5u94">
            50% OFF termina en:
          </span>
        </div>

        <div className="flex items-center gap-1 md:gap-2" data-id="element-418" data-mp="2fnewtdy41pbr">
          <div className="rounded-md border border-red-600 bg-red-950 px-2 py-1 text-center min-w-[40px] md:min-w-[52px] shadow-[0_0_12px_rgba(220,38,38,0.45)]" data-id="element-419" data-mp="2fkspnff4tbu2">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-400" data-id="element-420" data-mp="25no2bc9jvabo">
              {pad(hours)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-200 uppercase tracking-wider" data-id="element-421" data-mp="qa1o7ciytf4u">
              HRS
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-red-500" data-id="element-422" data-mp="2wwh4j6hr06n4">:</span>
          <div className="rounded-md border border-red-600 bg-red-950 px-2 py-1 text-center min-w-[40px] md:min-w-[52px] shadow-[0_0_12px_rgba(220,38,38,0.45)]" data-id="element-423" data-mp="2rxebkkf1lqvi">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-400" data-id="element-424" data-mp="2n4l96371quml">
              {pad(minutes)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-200 uppercase tracking-wider" data-id="element-425" data-mp="2e5ga8vrkoz9w">
              MIN
            </p>
          </div>
          <span className="text-xl md:text-2xl font-black text-red-500" data-id="element-426" data-mp="295211ae8jjaa">:</span>
          <div className="rounded-md border border-red-600 bg-red-950 px-2 py-1 text-center min-w-[40px] md:min-w-[52px] shadow-[0_0_12px_rgba(220,38,38,0.45)]" data-id="element-427" data-mp="248la68fniqti">
            <span className="text-lg md:text-2xl font-black tabular-nums text-red-400" data-id="element-428" data-mp="2fx4ztjg5tb3">
              {pad(seconds)}
            </span>
            <p className="text-[8px] md:text-[10px] font-bold text-red-200 uppercase tracking-wider" data-id="element-429" data-mp="3tnjbrv1gqbw6">
              SEG
            </p>
          </div>
        </div>
      </div>
    </div>;
}